import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const TraditionalAbmCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.TRADITIONAL_ABM}
    visibleOptionalPanels={[CAMPAIGN_STEPS.ROLE_TITLES, CAMPAIGN_STEPS.TARGET_COMPANIES]}
  />
);

export default TraditionalAbmCreatePageRedesign;
